import React, { useState } from "react";
import { SecondaryBody, H4 } from "text";
import { FlexRow } from "./ItemDetails";
import Collapsible from "../Collapsible";
import MySmallSelect from "./MySmallSelect";
import { InputAdornment } from "@material-ui/core";
import styles from "assets/jss/material-dashboard-pro-react/views/itemDetailsDrawerStyle.js";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(styles);

const Deals = ({
  packageQty,
  packageSaveHowMuch,
  setPackageQty,
  setPackageSaveHowMuch,
  canEdit,
}) => {
  return (
    <Collapsible listTitle="Deals">
      <NewDeal
        packageQty={packageQty}
        packageSaveHowMuch={packageSaveHowMuch}
        setPackageQty={setPackageQty}
        setPackageSaveHowMuch={setPackageSaveHowMuch}
        canEdit={canEdit}
      />
      {packageQty && packageSaveHowMuch && (
        <Deal
          packageQty={packageQty}
          packageSaveHowMuch={packageSaveHowMuch}
          setPackageQty={setPackageQty}
          setPackageSaveHowMuch={setPackageSaveHowMuch}
          canEdit={canEdit}
        />
      )}
    </Collapsible>
  );
};

const Deal = ({
  packageQty,
  packageSaveHowMuch,
  setPackageSaveHowMuch,
  setPackageQty,
  canEdit,
}) => {
  const classes = useStyles(styles);
  const handleDeleteDeal = () => {
    setPackageSaveHowMuch("");
    setPackageQty("");
  };
  return (
    <>
      <div className={classes.deal}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <H4>
            Buy {packageQty} Save ${packageSaveHowMuch}
          </H4>
          {canEdit && <H4 onClick={handleDeleteDeal}>Delete</H4>}
        </div>
      </div>
    </>
  );
};

const NewDeal = ({
  packageQty,
  packageSaveHowMuch,
  setPackageSaveHowMuch,
  setPackageQty,
  canEdit,
  ...rest
}) => {
  // const quantities = Array.from(Array(100).keys());
  // quantities.shift();
  return (
    <div {...rest}>
      <SecondaryBody>
        Set the number of products to purchase and the amount of savings
      </SecondaryBody>
      <FlexRow>
        <H4>Buy Quantity</H4>
        <MySmallSelect
          select={false}
          value={packageQty}
          style={{ maxWidth: "94px" }}
          InputProps={{
            startAdornment: <InputAdornment position="start">#</InputAdornment>,
            disabled: !canEdit,
          }}
          onChange={(e) => setPackageQty(e.target.value)}
        />
      </FlexRow>
      <FlexRow>
        <H4>Save How Much?</H4>
        <MySmallSelect
          select={false}
          value={packageSaveHowMuch}
          style={{ maxWidth: "94px" }}
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
            disabled: !canEdit,
          }}
          onChange={(e) => setPackageSaveHowMuch(e.target.value)}
        />
      </FlexRow>
    </div>
  );
};

export default Deals;
